import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const MonetizationPolicyPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="monetization-policy-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="monetization-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Creator Monetization Policy</h1>
            <p className="text-sm text-purple-300 mb-8">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <h2 className="text-2xl font-bold text-white">Earnings Buckets</h2>
              <p>RGM Studio separates three currency buckets so creators always know which earnings can be cashed out:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>💎 <span className="text-white font-semibold">Paid Coins</span> — purchased via Stripe. Earnings from paid-coin gifts are eligible for withdrawal after the hold period.</li>
                <li>🪙 <span className="text-white font-semibold">Reward Coins</span> — earned from quests, streaks, and platform bonuses. Non-cashable.</li>
                <li>🧪 <span className="text-white font-semibold">Test Coins</span> — admin-granted for previewing flows. Non-cashable.</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">Hold Period</h2>
              <p>Paid-coin gift earnings enter a <span className="text-white">7-day hold</span> before becoming withdrawable. This protects creators and the platform from chargebacks and fraud.</p>

              <h2 className="text-2xl font-bold text-white">Conversion Rate & Minimums</h2>
              <p>Conversion rate: <span className="text-white">$0.0075 per earned paid coin</span>. Minimum payout: <span className="text-white">$25 USD</span> (~3,334 coins). Maximum payout per request is your available withdrawable balance.</p>

              <h2 className="text-2xl font-bold text-white">Supported Payout Methods</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>PayPal</li>
                <li>Cash App</li>
                <li>Zelle</li>
                <li>Manual (admin-processed)</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">Approval Workflow</h2>
              <p>Payout requests are reviewed by an admin and marked Approved → Paid (with a reference ID) or Denied (with admin notes). Approval does not change your balance; only Mark-Paid does.</p>

              <h2 className="text-2xl font-bold text-white">Chargebacks & Fraud</h2>
              <p>Confirmed chargebacks reverse the related earnings entries. RGM Studio may withhold or claw back payouts traced to fraudulent purchases.</p>

              <h2 className="text-2xl font-bold text-white">Taxes</h2>
              <p>Creators are responsible for their own taxes on earnings received from RGM Studio.</p>

              <h2 className="text-2xl font-bold text-white">Contact</h2>
              <p>📧 <a className="text-purple-300 underline" href="mailto:realglobalmusicent@yahoo.com">realglobalmusicent@yahoo.com</a></p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MonetizationPolicyPage;
